import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tag } from '../Tag';

export const VisitBody = ({ visit }) => {
    const { t } = useTranslation('reportPage');

    return (
        <div className={`vbody${visit.isOpen ? '' : ' closed'}`}>
            {visit.complaint && visit.complaint.text && (
                <div className="vblock">
                    <div className="eyebrow">{t('journey.customerComplaint')}</div>
                    <blockquote className="complaint">
                        <div>{visit.complaint.text}</div>
                        {visit.complaint.original && <div className="orig src">{visit.complaint.original}</div>}
                    </blockquote>
                </div>
            )}
            {visit.complaint && visit.complaint.assessment && (
                <div className="vblock">
                    <div className="eyebrow">{t('journey.workshopAssessment')}</div>
                    <div className="optext src">{visit.complaint.assessment}</div>
                </div>
            )}
            {visit.ops.length > 0 && (
                <div className="vblock">
                    <div className="eyebrow">{t('journey.workPerformed')}</div>
                    {visit.ops.map((op, i) => (
                        <div className="oprow" key={`${op.code}-${i}`}>
                            {op.showCode && <span className="opcode">{op.code}</span>}
                            <div className="optext">
                                <span className="src">{op.text}</span>
                                {op.original && <div className="orig src">{op.original}</div>}
                            </div>
                            {op.maint && <Tag tone="success">{t('journey.maintenance')}</Tag>}
                            {op.paint && <Tag tone="warning">{t('journey.paint')}</Tag>}
                        </div>
                    ))}
                </div>
            )}
            {visit.parts.length > 0 && (
                <div className="vblock">
                    <div className="eyebrow">{t('journey.partsTitle')}</div>
                    {visit.parts.map((part, i) => (
                        <div className="oprow" key={`${part.no}-${i}`}>
                            {part.no && (
                                <span
                                    className="opcode"
                                    style={{ color: 'var(--tokens-text-primary)', fontSize: 13, minWidth: 120 }}
                                >
                                    {part.no}
                                </span>
                            )}
                            {part.text && <div className="optext src">{part.text}</div>}
                            {part.qty && <span style={{ fontSize: 14, fontWeight: 600 }}>× {part.qty}</span>}
                        </div>
                    ))}
                </div>
            )}
            {visit.refs.length > 0 && (
                <div className="refs">
                    {visit.refs.map((ref, refIndex) => (
                        <span key={refIndex}>{ref}</span>
                    ))}
                </div>
            )}
        </div>
    );
};
